/** The player market: the Market Scroll window, the stall preview on hover and their notices. */
export default {
  Market: "Pazar",
  "Every stall on this server. Buy from anywhere.":
    "Bu sunucudaki bütün tezgâhlar. Her yerden satın al.",
  Search: "Ara",
  Sort: "Sırala",
  "Lowest price": "En düşük fiyat",
  "Highest price": "En yüksek fiyat",
  Newest: "En yeni",
  Prev: "Önceki",
  Next: "Sonraki",
  "Page {page} / {pages}": "Sayfa {page} / {pages}",
  Yours: "Senin",
  "Click again to buy": "Almak için tekrar tıkla",
  "Searching...": "Aranıyor...",
  "Nothing on sale by that name": "Bu isimde satılan bir şey yok",
  "Nothing on sale right now": "Şu an satılan bir şey yok",
  "Click to see the stall": "Tezgâhı görmek için tıkla",
  Bought: "Satın alındı",
  "That is your own item": "Bu senin kendi eşyan",
  "The price changed: look again": "Fiyat değişti: tekrar bak",
  "You need a Market Scroll": "Pazar Kağıdı gerekiyor",
  "The stall could not open: try again": "Tezgâh açılamadı: tekrar dene",
  "You can set up a stall from level {n}": "Tezgâh {n}. seviyeden itibaren kurulabilir",
  "Too close to another stall": "Başka bir tezgâha çok yakın",
  "Market Scroll": "Pazar Kağıdı",
  "Keep it in your bag and use it to see every stall on the server and buy from anywhere.":
    "Çantanda tut ve kullan: sunucudaki bütün tezgâhları gör, her yerden satın al.",
  "Lasts {n} days": "{n} gün sürer",
  "Goes to your bag. Lasts {n} days.": "Çantana gelir. {n} gün sürer.",
} satisfies Record<string, string>;
